/* Elford Lane – cart drawer: replaces Horizon's drawer, refreshes via the Section Rendering API */
let Events = null;
try { Events = await import('@shopify/events'); } catch (e) { Events = null; }
const CLUE = Events && Events.CartLinesUpdateEvent;
const LINES_EVENT = Events && Events.StandardEvents && Events.StandardEvents.cartLinesUpdate;
const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const wrap = document.querySelector('[data-el-cart]');

if (wrap) {
  const id = wrap.dataset.sectionId;
  const panel = wrap.querySelector('.el-cart__panel');
  let lastFocus = null;
  let rendering = null;

  const render = async () => {
    try {
      const res = await fetch(`${root}?sections=${encodeURIComponent(id)}`, { headers: { Accept: 'application/json' } });
      const json = await res.json();
      const doc = new DOMParser().parseFromString(json[id], 'text/html');
      const fresh = doc.querySelector('[data-el-cart-content]');
      const cur = wrap.querySelector('[data-el-cart-content]');
      if (fresh && cur) { cur.innerHTML = fresh.innerHTML; window.ElfordLane && window.ElfordLane.init(cur); }
    } catch (e) { /* keep current content */ }
  };
  const refresh = () => (rendering = render().finally(() => (rendering = null)));

  const setOverlay = (on) => {
    document.documentElement.classList.toggle('el-cart-open', on);
    document.body.classList.toggle('el-overlay-open', on);
  };
  const open = async (doRefresh = true) => {
    if (!wrap.classList.contains('is-open')) lastFocus = document.activeElement;
    if (doRefresh) { wrap.classList.add('is-busy'); await refresh(); wrap.classList.remove('is-busy'); }
    wrap.classList.add('is-open');
    setOverlay(true);
    panel.focus({ preventScroll: true });
  };
  const close = () => {
    wrap.classList.remove('is-open');
    setOverlay(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  // Tell the theme (header cart count, etc.) that the cart changed.
  const notify = (cart, action) => {
    if (!CLUE) return;
    try {
      const d = CLUE.createPromise();
      wrap.dispatchEvent(new CLUE({ action, context: 'cart', lines: [], promise: d.promise }));
      d.resolve({ cart: CLUE.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'el-cart', didError: false } });
    } catch (e) { /* ignore */ }
  };

  const change = async (key, quantity) => {
    wrap.classList.add('is-busy');
    try {
      const cart = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      }).then((r) => r.json());
      await refresh();
      notify(cart, quantity === 0 ? 'remove' : 'update');
    } finally { wrap.classList.remove('is-busy'); }
  };

  wrap.addEventListener('click', async (e) => {
    if (e.target.closest('[data-el-cart-close]')) { e.preventDefault(); close(); return; }
    const q = e.target.closest('[data-el-cart-qty]');
    if (q) { e.preventDefault(); const item = q.closest('[data-key]'); if (item) change(item.dataset.key, Number(q.dataset.elCartQty)); return; }
    const ua = e.target.closest('[data-el-up-add]');
    if (ua) {
      e.preventDefault();
      const sel = ua.closest('.el-cart__up-form').querySelector('select');
      if (!sel || !window.ElfordLane) return;
      ua.classList.add('is-loading');
      try { await window.ElfordLane.addToCart([{ id: Number(sel.value), quantity: 1 }], ua); } catch (err) { /* shown by theme */ }
      ua.classList.remove('is-loading');
      open(true);
    }
  });
  wrap.addEventListener('click', (e) => { if (e.target.closest('[data-el-add]')) setTimeout(() => open(true), 900); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && wrap.classList.contains('is-open')) close(); });

  // Take over Horizon's cart drawer: any time the theme tries to open it, open ours instead.
  const hd = document.getElementById('cart-drawer');
  const hijack = () => {
    if (!hd) return;
    hd.open = () => { open(true); };
    hd.showDialog = hd.open;
  };
  if (hd) {
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('theme-drawer').then(hijack); else hijack();
    hijack();
    new MutationObserver(() => {
      if (hd.hasAttribute('open')) { try { HTMLElement.prototype.removeAttribute.call(hd, 'open'); const dlg = hd.querySelector('dialog'); dlg && dlg.open && dlg.close(); } catch (e) {} open(true); }
    }).observe(hd, { attributes: true, attributeFilter: ['open'] });
  }

  // Header cart icon / any link to the cart page opens the drawer instead.
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href$="/cart"], a[href="' + root + 'cart"], [on\\:click*="cart-drawer"]');
    if (!a || wrap.contains(a) || e.metaKey || e.ctrlKey) return;
    e.preventDefault(); e.stopPropagation();
    open(true);
  }, true);

  // Re-render whenever something else in the theme changes the cart (e.g. quick add on collection pages).
  if (LINES_EVENT) {
    document.addEventListener(LINES_EVENT, (e) => {
      if (e.target === wrap || (e.detail && e.detail.source === 'el-cart')) return;
      const p = e.promise || (e.detail && e.detail.promise);
      const after = () => { if (wrap.classList.contains('is-open')) refresh(); };
      p && p.then ? p.then(after, after) : after();
    });
  }

  window.ElfordLane = Object.assign(window.ElfordLane || {}, { openCart: open, closeCart: close });
}
